// extracted by mini-css-extract-plugin
export default {"container":"AssetItem_container__VAJjv","imageContainer":"AssetItem_imageContainer__zrH-M","assetImage":"AssetItem_assetImage__R-3FP"};